// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"457":"48c1e64c","484":"7bf68f41","498":"aabbefe7","551":"b094ac8b","842":"23a53ad5"}[chunkId] + ".chunk.js";
};